import './draggable-mixin.scss';
import { addPointerListener, removePointerListener } from 'uScope/js/lib/utility/pointerApi';

const draggable = {
  methods: {
    setDragTarget (el, elContext) {
      this.__dragTarget__ = el;
      this.__dragTarget__.className += ' draggable';
      addPointerListener(this.__dragTarget__, 'mousedown', this.__dragInit__);

      // only needed outside vue
      if (!this.$el) {
        this.$el = elContext || el;
      }
    },

    setIgnoreTarget (el) {
      this.__ignoreTarget = el;
    },

    __shouldIgnore__ (e) {
      return this.__ignoreTarget && e.target === this.__ignoreTarget;
    },

    __dragInit__ (e) {
      if (this.__shouldIgnore__(e)) {
        return;
      }
      this.__dragOrigin__ = {
        // If the control tells us where the element is, trust it. Fallback to browser. Note that browser
        // reports elements position relative to the document, which isn't reliable if the element is positioned
        // relative to some other element.
        element: this.getPosition ? this.getPosition() : this.$el.getBoundingClientRect(),
        mouse: {
          x: e.clientX,
          y: e.clientY
        }
      };

      addPointerListener(document, 'mouseup', this.__dragEnd__);
      // Oddly, throttling this appears to make performance worse, in all browsers.
      addPointerListener(document, 'mousemove', this.__drag__);
      return false;
    },

    __drag__ (e) {
      if (this.__shouldIgnore__(e)) {
        return;
      }
      const dragOffset = {
        x: this.__dragOrigin__.mouse.x - e.clientX,
        y: this.__dragOrigin__.mouse.y - e.clientY
      };

      let leftPosition = this.__dragOrigin__.element.left - dragOffset.x;
      let topPosition = this.__dragOrigin__.element.top - dragOffset.y;

      const dragTargetWidth = this.__dragTarget__.clientWidth;
      const dragTargetHeight = this.__dragTarget__.clientHeight;

      // Sets the width of web page minus width and height of dialog
      const rightPosition = e.view.innerWidth - dragTargetWidth;
      const bottomPosition = e.view.innerHeight - dragTargetHeight;

      // Sets max and min for left, right , top and bottom
      leftPosition = constrain(leftPosition, 0, rightPosition);
      topPosition = constrain(topPosition, 0, bottomPosition);

      this.moveTo({
        left: `${leftPosition}px`,
        top: `${topPosition}px`
      });
      return false;
    },

    __dragEnd__ () {
      delete this.__dragOrigin__;
      removePointerListener(document, 'mouseup', this.__dragEnd__);
      removePointerListener(document, 'mousemove', this.__drag__);
      return false;
    }
  }
};

export default draggable;

export function makeDraggable (el, contextEl, ignoreEl) {
  let position;
  function paint () {
    el.style.left = position.left;
    el.style.top = position.top;
    position = null;
  }
  const out = Object.assign({}, {
    getPosition () {
      // Extract the left and top positions from the el's transform styling.
      return {
        left: parseInt(el.style.left, 10),
        top: parseInt(el.style.top, 10)
      };
    },
    // Used by the draggable mixin to reposition the dialog.
    moveTo (newPosition) {
      if (!position) {
        requestAnimationFrame(paint);
      }
      position = newPosition;
    }
  });

  // Apply the draggable mixin, allowing this control to be dragged.
  Object.keys(draggable.methods).forEach((method) => {
    out[method] = draggable.methods[method].bind(out);
  });

  out.setDragTarget(el, contextEl);
  if (ignoreEl) {
    out.setIgnoreTarget(ignoreEl);
  }

  return out;
}

function constrain (value, min, max) {
  if (value <= min) {
    return min;
  } else if (value >= max) {
    return max;
  } else {
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/components/mixins/draggable-mixin.js